"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTimestamp = exports.TimestampStruct = void 0;
const superstruct_1 = require("superstruct");
exports.TimestampStruct = new superstruct_1.Struct({
    type: 'firestore-timestamp',
    schema: {},
    validator: (value) => {
        // valid if seconds and nanoseconds are present
        if (value && typeof value == 'object' && 'seconds' in value && 'nanoseconds' in value) {
            return true;
        }
        else {
            return 'Value must be a Timestamp object';
        }
    },
});
function isTimestamp(obj) {
    return exports.TimestampStruct.is(obj);
}
exports.isTimestamp = isTimestamp;
//# sourceMappingURL=Timestamp.js.map